import { memo } from 'react';
import { FileOutlet } from './FileOutlet';

interface PageLoaderProps {
    search?: "global" | "local" | "none";
    match?: "any" | "exact";
}

/***
 * This component marks the place where the content of the current page is rendered.
 * This is needed because there is a wrapping file that contains things like page header,
 * and the content of the page is rendered inside that wrapper.
 */
export const PageLoader = memo(function PageLoader({ search = "none", match }: PageLoaderProps) {
    return <FileOutlet search={search} source="file" match={match} />;
});
